/**
 * Date-extensions locale Telugu [te]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('te', {
    monthNames: ['జనవరి','ఫిబ్రవరి','మార్చి','ఏప్రిల్','మే','జూన్','జూలై','ఆగస్టు','సెప్టెంబర్','అక్టోబర్','నవంబర్','డిసెంబర్'],
    monthShortNames: ['జన.','ఫిబ్ర.','మార్చి','ఏప్రి.','మే','జూన్','జూలై','ఆగ.','సెప్.','అక్టో.','నవ.','డిసె.'],
    dayNames: ['ఆదివారం','సోమవారం','మంగళవారం','బుధవారం','గురువారం','శుక్రవారం','శనివారం'],
    dayShortNames: ['ఆది','సోమ','మంగళ','బుధ','గురు','శుక్ర','శని']
});
